import{auto}from'../enums.js';export default function getBasePlacement(_0x2278bb){return _0x2278bb['split']('-')[0x0];}